import { render, staticRenderFns } from "./ChamarGarcomView.vue?vue&type=template&id=46e995cf&scoped=true&"
import script from "./ChamarGarcomView.vue?vue&type=script&lang=js&"
export * from "./ChamarGarcomView.vue?vue&type=script&lang=js&"
import style0 from "./ChamarGarcomView.vue?vue&type=style&index=0&id=46e995cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e995cf",
  null
  
)

export default component.exports